module.exports = __webpack_public_path__ + "img/732a37267a4841c5b100bad721d4018d.png";